import type { Article } from '@/types/content';

export const articles: Article[] = [
  {
    slug: 'liuliang-tuichao',
    title: '流量退潮之后：娱乐话题为什么越来越"短命"了',
    seoTitle: '流量退潮之后：娱乐话题为什么越来越短命 - 吃瓜网',
    category: 'yule-redian',
    excerpt:
      '同一个话题，三年前能热上两星期，现在可能两天就没了声音。讨论的热度变快，背后是平台节奏、内容供给和注意力分配共同作用的结果。',
    lead:
      '如果你最近常刷娱乐内容，大概会有一种感觉：昨天还在被反复讨论的事，今天就像没发生过一样。话题并不是变得不重要了，而是它被消费的速度变快了。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20fading%20concentric%20ripple%20rings%20on%20a%20cream%20paper%20background%2C%20coral%20orange%20and%20deep%20green%20accents%2C%20abstract%20metaphor%20for%20short-lived%20attention%20and%20fading%20trends%20with%20soft%20grain%20texture&width=1200&height=800&seq=chigua-redian-01&orientation=landscape',
    tags: ['注意力', '热点周期', '内容节奏'],
    author: '瓜田观察组',
    publishedAt: '2026-08-12',
    updatedAt: '2026-08-20',
    readingTime: 6,
    featured: true,
    editorPick: true,
    content: [
      {
        type: 'p',
        text: '一个娱乐话题从出现到被遗忘，中间大约要经历三个阶段：被看见、被放大、被替换。真正变化最大的是第三步——它现在来得比过去快得多。过去一条热搜能在榜上待很久，靠的是信息稀缺；现在每个人都身在无数个信息流里，注意力被切成了更小的碎片。',
      },
      {
        type: 'h2',
        text: '一、话题的"保鲜期"由谁来定',
      },
      {
        type: 'p',
        text: '很多人以为话题的寿命取决于事件本身的大小。其实更直接的影响来自供给端：当同时有足够多的新内容在竞争同一批用户，任何单个话题都不可能长期占据注意力。内容供给越充足，单个话题的保鲜期就越短。',
      },
      {
        type: 'p',
        text: '这对观众来说是一把双刃剑。好消息是你几乎不会错过什么，因为真正重要的东西会被反复提及；坏消息是，你很难再把一件小事反复品味很久，讨论很快就滑向了下一条。',
      },
      {
        type: 'h2',
        text: '二、平台的推荐节奏在改写讨论节奏',
      },
      {
        type: 'p',
        text: '推荐机制喜欢新鲜、喜欢正在上升的曲线。当一个话题的讨论量开始走平，系统就会把位置让给上升更快的内容。于是讨论的峰值越来越高、越来越尖，退潮也来得越来越干脆。',
      },
      {
        type: 'list',
        items: [
          '入口变多：同一条内容可以通过视频、图文、评论区、二次创作等很多形式出现，用户触达路径被拉长也被分散。',
          '反馈变快：一条内容是否值得继续推，通常在很短时间内就能得到数据回应。',
          '创作变密：围绕同一话题的解读和二次创作会在极短时间内集中爆发，讨论很快被"用尽"。',
        ],
      },
      {
        type: 'h2',
        text: '三、短命并不等于没有价值',
      },
      {
        type: 'p',
        text: '话题变短，不代表它没有留下东西。真正有内容的话题会沉淀下来：被写进长文、被做成纪录片式的内容、被当作行业案例反复引用。热度曲线结束了，影响却可能刚开始。',
      },
      {
        type: 'quote',
        text: '热闹决定了一件事被多少人看到，深度决定了这件事被记住多久。',
      },
      {
        type: 'p',
        text: '所以与其感叹"怎么这么快就没人聊了"，不如换个角度：在这场快速的信息更替里，哪些内容值得你停下来多看一眼。能在潮水退去后还留得下来的，才是真正值得花时间的部分。',
      },
    ],
    related: ['resou-dao-changwen', 'luyan-chonghuo', 'resou-zhiwai'],
  },
  {
    slug: 'resou-dao-changwen',
    title: '从热搜到长文：娱乐内容正在悄悄变"深"',
    seoTitle: '从热搜到长文：娱乐内容正在悄悄变深 - 吃瓜网',
    category: 'yule-redian',
    excerpt:
      '当短内容把话题推到所有人面前，用户反而开始主动寻找更完整的解释。于是长文、播客和深度视频，重新成了娱乐内容的另一半。',
    lead:
      '短内容负责让你知道发生了什么，长内容负责让你明白为什么。这两种形态并不是互相取代，而是正在形成一种新的分工。',
    cover:
      'https://readdy.ai/api/search-image?query=Minimal%20editorial%20illustration%20of%20a%20long%20scroll%20of%20paper%20unfolding%20next%20to%20tiny%20chat%20bubbles%2C%20cream%20background%20with%20coral%20and%20bamboo%20green%20blocks%2C%20symbolizing%20the%20shift%20from%20short%20updates%20to%20in-depth%20reading%2C%20flat%20vector%20style&width=1200&height=800&seq=chigua-redian-02&orientation=landscape',
    tags: ['长内容', '阅读习惯', '内容形态'],
    author: '瓜田观察组',
    publishedAt: '2026-07-28',
    updatedAt: '2026-08-05',
    readingTime: 5,
    editorPick: true,
    content: [
      {
        type: 'p',
        text: '一个话题被短视频推到眼前时，它往往只剩下一个结论。但当这个结论让你产生疑问，你就会去找更长、更完整的解释。这个从"知道"到"想弄明白"的转移，正是长内容重新被需要的起点。',
      },
      {
        type: 'h2',
        text: '短内容负责触达，长内容负责解释',
      },
      {
        type: 'p',
        text: '这两种形态的效率并不一样。短内容擅长在几秒内建立一个印象，但它天然装不下背景、因果和不同的声音。长内容的成本更高，却能把一件事的来龙去脉铺平，让读者自己判断。',
      },
      {
        type: 'table',
        head: ['维度', '短内容', '长内容'],
        rows: [
          ['核心作用', '快速触达与建立印象', '补充背景与解释因果'],
          ['阅读成本', '低，随时可以中断', '较高，需要连续注意力'],
          ['适合场景', '了解正在发生什么', '弄明白为什么会这样'],
          ['留下的东西', '一个结论', '一套理解框架'],
        ],
      },
      {
        type: 'h2',
        text: '为什么用户开始愿意多读一点',
      },
      {
        type: 'list',
        items: [
          '信息过载之后，用户开始对"太快得出结论"产生警惕。',
          '讨论越来越复杂，单一的短视频很难讲清楚一件事的全貌。',
          '听播客、看长视频、读长文的场景变多了，碎片时间之外也出现了整块时间。',
        ],
      },
      {
        type: 'quote',
        text: '深度不是把话说长，而是在同样的篇幅里，给出更完整的因果。',
      },
      {
        type: 'h2',
        text: '对内容创作者的启示',
      },
      {
        type: 'p',
        text: '如果一个话题只值得一句结论，那就用一句话讲完。但如果它值得被真正理解，就别怕写长。用户并不拒绝长内容，他们拒绝的是没有信息量的长内容。',
      },
    ],
    related: ['liuliang-tuichao', 'regeng-72xiaoshi', 'lixing-chigua-zhinan'],
  },
  {
    slug: 'luyan-chonghuo',
    title: '数据之外的现场：剧集路演为什么又火了',
    seoTitle: '数据之外的现场：剧集路演为什么又火了 - 吃瓜网',
    category: 'yule-redian',
    excerpt:
      '在播放数据之外，线下路演正在成为剧集和演员被重新认识的地方。面对面的现场，补上了数据永远给不了的那部分信息。',
    lead:
      '当数据成为衡量一切的标尺，线下现场反而成了稀缺品。因为在那里，你能看到数据表上看不到的东西：反应、停顿和真实的现场感。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20stylized%20illustration%20of%20a%20small%20theatre%20stage%20with%20soft%20spotlight%20and%20rows%20of%20seats%2C%20cream%20and%20caramel%20tones%20with%20coral%20accents%2C%20abstract%20crowd%20silhouettes%2C%20cozy%20editorial%20poster%20style%20with%20gentle%20grain&width=1200&height=800&seq=chigua-redian-03&orientation=landscape',
    tags: ['路演', '现场', '剧集宣传'],
    author: '瓜田观察组',
    publishedAt: '2026-07-15',
    updatedAt: '2026-07-22',
    readingTime: 5,
    content: [
      {
        type: 'p',
        text: '一部剧上线之后，主创通常会出现在不同城市的活动现场，与观众面对面交流。这几年，这类路演的关注度明显回升，原因不只是宣传需要，更在于它提供了一种数据无法替代的真实反馈。',
      },
      {
        type: 'h2',
        text: '现场带来的是"在场感"',
      },
      {
        type: 'p',
        text: '数据可以告诉你多少人看了，却很难告诉你他们当时的感受。而在现场，提问的语气、笑声的节奏、沉默的长短，都是最直接的信息。对这种感受的记录和转述，往往能带动没到场的人也产生兴趣。',
      },
      {
        type: 'h2',
        text: '为什么主创越来越重视线下',
      },
      {
        type: 'steps',
        items: [
          '线下活动产出的内容更具现场感，更容易被二次传播。',
          '面对面的交流能修正一些被数据放大的误解。',
          '观众对"真实互动"的需求在上升，套路化的宣传反而容易被识破。',
          '现场片段可以成为剧集之外的独立看点，延长内容的有效期。',
        ],
      },
      {
        type: 'quote',
        text: '最好的宣传不是告诉观众这部剧有多好，而是让观众自己感受到它值得看。',
      },
      {
        type: 'p',
        text: '当然，现场也并非万能。如果内容本身撑不起来，再热闹的路演也只是短暂的热度。真正能让现场被记住的，永远是作品本身。',
      },
    ],
    related: ['liuliang-tuichao', 'zongyi-shengming-zhouqi', 'manzongyi-huichao'],
  },
  {
    slug: 'xuanyi-pilao',
    title: '悬疑剧扎堆，观众为什么会审美疲劳',
    seoTitle: '悬疑剧扎堆，观众为什么会审美疲劳 - 吃瓜网',
    category: 'reju-zong',
    excerpt:
      '当同一种类型在短时间内反复出现，套路就会被观众提前预判。悬疑剧的疲劳，本质上不是题材的问题，而是结构和表达重复的问题。',
    lead:
      '一个类型火起来之后，市场会迅速跟进。问题在于，跟进者往往学走的是外壳，而把最花时间的部分——结构和节奏——留给了自己。',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20but%20warm%20editorial%20illustration%20of%20stacked%20empty%20picture%20frames%20with%20question%20marks%2C%20deep%20green%20and%20coral%20on%20cream%20paper%2C%20abstract%20metaphor%20for%20repetitive%20mystery%20dramas%20and%20genre%20fatigue%2C%20flat%20vector%20texture&width=1200&height=800&seq=chigua-juzong-01&orientation=landscape',
    tags: ['悬疑剧', '类型化', '叙事节奏'],
    author: '剧综观察组',
    publishedAt: '2026-08-03',
    updatedAt: '2026-08-11',
    readingTime: 6,
    editorPick: true,
    content: [
      {
        type: 'p',
        text: '悬疑是最容易让人上头的类型之一：一个未解的问题，就足以让人一集接一集地看下去。但当它变成市场上的主流选题，观众的耐心就会被一点点消耗。',
      },
      {
        type: 'h2',
        text: '疲劳感的来源是"可预测"',
      },
      {
        type: 'p',
        text: '真正让人失去兴趣的，不是案件本身，而是叙事方式变得可以预判。当观众在第三集就能猜到凶手、在第五集就能预判反转时，悬疑最核心的吸引力就消失了。',
      },
      {
        type: 'list',
        items: [
          '开场用同一个悬念手法：一具尸体、一段倒叙、一场雨夜。',
          '中段用同样的信息节奏：每集抛出一个微不足道的线索拖住进度。',
          '结尾用同样的解释方式：反转靠新增信息而不是原有伏笔。',
        ],
      },
      {
        type: 'h2',
        text: '类型不是问题，重复才是',
      },
      {
        type: 'p',
        text: '同一类型完全可以反复被拍，前提是每部作品都能找到属于自己的新鲜角度。观众并不排斥悬疑，他们排斥的是换了一批人、换了一个案子，却讲着同一个故事的悬疑。',
      },
      {
        type: 'quote',
        text: '类型的生命力来自于它被不断重新解释的能力。',
      },
      {
        type: 'h2',
        text: '怎么判断一部悬疑剧值不值得追',
      },
      {
        type: 'steps',
        items: [
          '看第有一集是否建立了独特的世界观，而不只是抛出一个案件。',
          '看线索是否服务于人物，而不是纯粹为了拖延时长。',
          '看结局的解答是否来自前面埋下的伏笔，而不是临时加设定。',
        ],
      },
    ],
    related: ['manzongyi-huichao', 'zongyi-shengming-zhouqi', 'liuliang-tuichao'],
  },
  {
    slug: 'manzongyi-huichao',
    title: '慢综艺回潮：为什么"没有剧情"反而更下饭',
    seoTitle: '慢综艺回潮：为什么没有剧情反而更下饭 - 吃瓜网',
    category: 'reju-zong',
    excerpt:
      '不设关卡、不做任务的慢综艺，正在重新回到观众的观看列表里。它提供的不是刺激，而是一种可以长时间陪伴的轻松感。',
    lead:
      '快综艺让你一直想知道下一秒会发生什么，慢综艺让你根本不想知道。这种"不用投入太多"的陪伴感，恰恰是它在当下重新被需要的原因。',
    cover:
      'https://readdy.ai/api/search-image?query=Calm%20warm%20illustration%20of%20a%20cozy%20room%20with%20a%20small%20table%2C%20tea%20cup%20and%20window%20with%20soft%20daylight%2C%20cream%20and%20bamboo%20green%20palette%20with%20coral%20accents%2C%20minimal%20flat%20vector%20style%20evoking%20slow%20variety%20shows&width=1200&height=800&seq=chigua-juzong-02&orientation=landscape',
    tags: ['慢综艺', '陪伴感', '观看场景'],
    author: '剧综观察组',
    publishedAt: '2026-07-20',
    updatedAt: '2026-07-30',
    readingTime: 5,
    content: [
      {
        type: 'p',
        text: '慢综艺几乎和"综艺"这个词的常规想象相反：没有激烈的竞争，没有密集的关卡，画面里可能只是几个人在做饭、聊天、发呆。可正是这种松弛，让它在很多人的播放列表里占了一个固定位置。',
      },
      {
        type: 'h2',
        text: '它满足的是一种低投入的陪伴',
      },
      {
        type: 'p',
        text: '快综艺需要观众保持注意力，随时准备迎接笑点或转折。慢综艺则允许你一边做别的事一边看，错过了几分钟也不影响理解。对忙碌的人来说，这是一种宝贵的低门槛体验。',
      },
      {
        type: 'table',
        head: ['观看需求', '快综艺', '慢综艺'],
        rows: [
          ['注意力投入', '高，需要连续跟进', '低，可以随时中断'],
          ['情绪感受', '刺激、惊喜', '放松、安心'],
          ['适合场景', '专门坐下来看', '吃饭、做家务时背景播放'],
        ],
      },
      {
        type: 'h2',
        text: '慢不等于没有设计',
      },
      {
        type: 'p',
        text: '优秀的慢综艺其实非常考验制作：画面要好看，节奏要舒服，嘉宾的化学反应要自然。它只是把设计藏了起来，让观众感觉不到"被安排"。这种"看起来没有设计的设计"，恰恰是最难的部分。',
      },
      {
        type: 'quote',
        text: '好的慢综艺不是让人无话可说，而是让该说的话在合适的时候自然地说出来。',
      },
    ],
    related: ['zongyi-shengming-zhouqi', 'xuanyi-pilao', 'chigua-zhengque-zishi'],
  },
  {
    slug: 'zongyi-shengming-zhouqi',
    title: '一档综艺能火多久？从话题度看节目的生命周期',
    seoTitle: '一档综艺能火多久：节目生命周期观察 - 吃瓜网',
    category: 'reju-zong',
    excerpt:
      '几乎所有爆款综艺都会经历上升、高峰、平稳和降温四个阶段。理解这个周期，能帮我们判断一档节目是在成长，还是在消耗自己。',
    lead:
      '节目热度像一条曲线：它会有明确的起点、陡峭的上升、短暂的顶点，然后进入漫长的下坡。区别只在于，有些节目能靠调整把曲线第二次拉起来，有些只能一路走低。',
    cover:
      'https://readdy.ai/api/search-image?query=Clean%20editorial%20illustration%20of%20a%20rising%20and%20falling%20trend%20line%20made%20of%20small%20dots%20above%20rounded%20bar%20shapes%2C%20cream%20background%20with%20coral%20and%20green%2C%20abstract%20chart%20for%20show%20lifecycle%2C%20flat%20vector%20style&width=1200&height=800&seq=chigua-juzong-03&orientation=landscape',
    tags: ['生命周期', '话题度', '综艺制作'],
    author: '剧综观察组',
    publishedAt: '2026-06-28',
    updatedAt: '2026-07-06',
    readingTime: 6,
    content: [
      {
        type: 'p',
        text: '一档综艺的热度并不是均匀分布的。理解它的周期，不只是为了预测它什么时候降温，更是为了看懂制作方在每个阶段做了什么选择。',
      },
      {
        type: 'h2',
        text: '四个阶段，各有各的任务',
      },
      {
        type: 'steps',
        items: [
          '上升期：核心任务是让第一批观众记住节目的独特设置，形成讨论种子。',
          '高峰期：话题集中爆发，节目需要承接关注度，避免口碑失控。',
          '平稳期：新鲜感下降，需要靠人物关系和稳定内容留住老观众。',
          '降温期：讨论趋缓，节目要么升级形态，要么体面收尾，避免强行续命。',
        ],
      },
      {
        type: 'h2',
        text: '大多数节目死在平稳期',
      },
      {
        type: 'p',
        text: '真正考验制作能力的，是热度下降后的那一段。此时节目的初始卖点已经不再新鲜，如果没有新的内容支点，就只能靠放大冲突维持话题，而这样往往会加速口碑的下滑。',
      },
      {
        type: 'quote',
        text: '一档节目能不能走得远，看它在失去新鲜感之后还剩什么。',
      },
      {
        type: 'p',
        text: '所以判断一档综艺值不值得继续追，不妨看看它现在已经走到周期里的哪个位置。上升期的节目值得期待，而进入降温期却还在不断加码冲突的节目，通常已经在消耗自己了。',
      },
    ],
    related: ['manzongyi-huichao', 'xuanyi-pilao', 'regeng-72xiaoshi'],
  },
  {
    slug: 'regeng-72xiaoshi',
    title: '一个热梗的72小时：网络流行语的传播路径拆解',
    seoTitle: '一个热梗的72小时：网络热梗传播路径拆解 - 吃瓜网',
    category: 'wangluo-regeng',
    excerpt:
      '从一个不起眼的片段，到全网刷屏，一个梗往往只需要三天。这三天里发生了什么？把它的传播路径拆开看，会非常有意思。',
    lead:
      '热梗的诞生很少有明确的"发明者"。它更像是一场接力：第一个人用了一个说法，第二个人觉得有趣跟着用，到第一百个人时，它已经变成了所有人的语言。',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20abstract%20illustration%20of%20many%20small%20speech%20bubbles%20spreading%20outward%20in%20a%20chain%20reaction%2C%20cream%20background%20with%20coral%20orange%20and%20deep%20green%2C%20flat%20vector%20editorial%20style%20about%20viral%20internet%20catchphrases&width=1200&height=800&seq=chigua-regeng-01&orientation=landscape',
    tags: ['传播路径', '流行语', '网络文化'],
    author: '网络观察组',
    publishedAt: '2026-08-18',
    updatedAt: '2026-08-22',
    readingTime: 6,
    featured: true,
    content: [
      {
        type: 'p',
        text: '大多数热梗都是从一段很普通的素材开始的：一句台词、一个表情、一段被截出来的反应。它本身并不特别，特别的是它被使用的速度。',
      },
      {
        type: 'h2',
        text: '第 0-12 小时：种子阶段',
      },
      {
        type: 'p',
        text: '这一阶段，梗只在小圈子里流传，通常是某个兴趣社区或话题下。此时它还有明确的语境，使用者知道它从哪来、在什么场合用。判断一个梗能否出圈，往往就看它能不能脱离原始语境单独成立。',
      },
      {
        type: 'h2',
        text: '第 12-48 小时：加速阶段',
      },
      {
        type: 'list',
        items: [
          '创作者发现它能带来互动，开始主动使用和改编。',
          '梗被简化、切断语境，变成一句可以脱场景使用的话。',
          '仿句式大量出现，用户开始用它套自己的生活场景。',
        ],
      },
      {
        type: 'h2',
        text: '第 48-72 小时：饱和阶段',
      },
      {
        type: 'p',
        text: '当所有人都开始用它，它的新鲜感就开始衰减。此时真正的考验来了：如果这个梗能被固定成一种表达方式，它会留下来；如果它只是一种短暂的玩法，那么三天之后就会迅速退潮。',
      },
      {
        type: 'quote',
        text: '能留下来的梗，最后都变成了语言的一部分，而不是一个需要解释的笑话。',
      },
    ],
    related: ['laogeng-fanhong', 'wan-geng-dao-zao-geng', 'resou-dao-changwen'],
  },
  {
    slug: 'laogeng-fanhong',
    title: '老梗为什么会反复翻红',
    seoTitle: '老梗为什么会反复翻红 - 吃瓜网',
    category: 'wangluo-regeng',
    excerpt:
      '很多已经"过气"多年的老梗，会突然在某个节点重新流行。翻红不是偶然，它通常对应着某种当下的情绪需求。',
    lead:
      '梗的翻红几乎总有一个共同点：它被重新使用的时候，恰好说出了一群人当下的心情。老梗并不迟钝，迟钝的是还没发现自己需要它的人。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20illustration%20of%20a%20vintage%20radio%20and%20old%20photo%20frames%20glowing%20back%20to%20life%20with%20soft%20rings%2C%20cream%20and%20caramel%20palette%20with%20coral%20highlights%2C%20flat%20vector%20editorial%20style%20about%20revived%20old%20memes&width=1200&height=800&seq=chigua-regeng-02&orientation=landscape',
    tags: ['怀旧', '翻红', '情绪共鸣'],
    author: '网络观察组',
    publishedAt: '2026-07-09',
    updatedAt: '2026-07-18',
    readingTime: 5,
    content: [
      {
        type: 'p',
        text: '每隔一段时间，总会有一些你以为早就被遗忘的老梗重新出现在首页。它们通常来自几年前的综艺、动画或影视片段，重新被使用时却毫无违和感。',
      },
      {
        type: 'h2',
        text: '翻红的核心是情绪对上了',
      },
      {
        type: 'p',
        text: '一句老话能在新的时间点复活，往往是因为当下的某种集体情绪正好被它说中。可能是无奈，可能是疲惫，也可能只是一种"我懂的"的会心一笑。梗只是容器，装的是现在的情绪。',
      },
      {
        type: 'h2',
        text: '三种常见的翻红路径',
      },
      {
        type: 'steps',
        items: [
          '怀旧型：一段老内容被重新发现，唤起一群人的共同记忆。',
          '错位型：老梗被放进完全不同的场景，产生新的反差笑点。',
          '情绪型：老梗原本的中性含义被赋予新的态度，成为表达立场的工具。',
        ],
      },
      {
        type: 'quote',
        text: '梗从不会真正消失，它只是等着被重新需要。',
      },
      {
        type: 'p',
        text: '理解翻红机制，能帮我们更理性地看待流行语：没有任何一个梗是天生的经典，也没有任何一个梗会真正被删除，它们只是暂时安静下来而已。',
      },
    ],
    related: ['regeng-72xiaoshi', 'wan-geng-dao-zao-geng', 'resou-zhiwai'],
  },
  {
    slug: 'wan-geng-dao-zao-geng',
    title: '从"玩梗"到"造梗"：普通人如何参与网络文化',
    seoTitle: '从玩梗到造梗：普通人如何参与网络文化 - 吃瓜网',
    category: 'wangluo-regeng',
    excerpt:
      '过去我们只是流行语的使用者，现在越来越多的人开始成为它的生产者。造梗的门槛，比想象中低得多。',
    lead:
      '一个梗能不能流行，最终取决于有多少人愿意用它。这意味着，每一个使用它的人，其实都在参与它的塑造。',
    cover:
      'https://readdy.ai/api/search-image?query=Bright%20friendly%20illustration%20of%20many%20hands%20passing%20small%20glowing%20blocks%20along%20a%20line%2C%20cream%20background%20with%20coral%20and%20green%20geometry%2C%20flat%20vector%20metaphor%20for%20people%20co-creating%20internet%20culture&width=1200&height=800&seq=chigua-regeng-03&orientation=landscape',
    tags: ['造梗', '参与式文化', '二次创作'],
    author: '网络观察组',
    publishedAt: '2026-06-20',
    updatedAt: '2026-06-29',
    readingTime: 5,
    content: [
      {
        type: 'p',
        text: '过去的网络流行语，大多由少数内容和平台带动。现在不一样了：一个普通人的随口一说，只要被足够多的人接住，就有可能变成新的梗。',
      },
      {
        type: 'h2',
        text: '造梗其实只需要三步',
      },
      {
        type: 'steps',
        items: [
          '找到一个可复用的句式或画面，它要足够简单，别人一眼就能理解。',
          '把它放进一个具体场景里用出来，让抽象的说法变成能看懂的画面。',
          '给它留出改造空间，让后来的人可以接着往下玩，而不是只负责转发。',
        ],
      },
      {
        type: 'h2',
        text: '参与式文化的两个特点',
      },
      {
        type: 'list',
        items: [
          '开放：没有谁拥有一个梗的最终解释权，含义在使用中不断被重新定义。',
          '平等：影响力不再只属于大号，任何一个准确的表达都可能被放大。',
        ],
      },
      {
        type: 'quote',
        text: '造梗的门槛，从来不是创意，而是敢不敢把自己的表达放到人群里。',
      },
      {
        type: 'p',
        text: '当然，参与也意味着责任。当你有机会定义一个说法，也就有机会决定它会被如何使用。用得好，它是共鸣；用不好，它可能变成伤人的工具。',
      },
    ],
    related: ['regeng-72xiaoshi', 'laogeng-fanhong', 'chigua-zhengque-zishi'],
  },
  {
    slug: 'chigua-zhengque-zishi',
    title: '吃瓜的正确姿势：围观、讨论与边界感',
    seoTitle: '吃瓜的正确姿势：围观、讨论与边界感 - 吃瓜网',
    category: 'guquan-guancha',
    excerpt:
      '围观本身没有错，但围观的方式有区别。保持好奇，同时守住边界，才是让"吃瓜"这件事不至于失控的关键。',
    lead:
      '我们都有过被某个话题吸引、忍不住想多看一眼的时刻。这不丢人——好奇心是人最正常的一部分。问题从来不在"要不要看"，而在"看完之后怎么做"。',
    cover:
      'https://readdy.ai/api/search-image?query=Thoughtful%20editorial%20illustration%20of%20a%20circle%20of%20people%20looking%20at%20a%20soft%20glowing%20center%20with%20a%20calm%20line%20around%20it%2C%20cream%20background%20with%20coral%20and%20deep%20green%2C%20flat%20vector%20about%20healthy%20boundaries%20in%20gossip&width=1200&height=800&seq=chigua-guancha-01&orientation=landscape',
    tags: ['边界感', '围观', '讨论礼仪'],
    author: '瓜圈观察组',
    publishedAt: '2026-08-25',
    updatedAt: '2026-09-02',
    readingTime: 6,
    featured: true,
    editorPick: true,
    content: [
      {
        type: 'p',
        text: '吃瓜这个词本身就带着一点轻松和距离感：你不是当事人，你只是一个看客。但看客也有看客的分寸，尤其是当讨论的对象是真实的人时。',
      },
      {
        type: 'h2',
        text: '第一层边界：区分事实和猜测',
      },
      {
        type: 'p',
        text: '很多讨论一开始是围绕事实的，慢慢地就被猜测接管了。当"我听说"取代了"我确认"，讨论就已经越过了第一条线。对不确定的信息，最稳妥的做法是标注清楚：这是猜测，不是结论。',
      },
      {
        type: 'h2',
        text: '第二层边界：讨论事情，不攻击人',
      },
      {
        type: 'list',
        items: [
          '对行为的批评和对人身的攻击，是两件完全不同的事。',
          '把一个人简化成一个标签，往往意味着你已经放弃了理解。',
          '在情绪最激烈的时候留言，事后回看通常只剩后悔。',
        ],
      },
      {
        type: 'h2',
        text: '第三层边界：允许自己不知道',
      },
      {
        type: 'p',
        text: '信息不全的时候，沉默并不等于冷漠。相反，急着给一个话题盖棺定论，才是最容易出错的。允许自己说一句"等更多信息出来再说"，是一种成熟。',
      },
      {
        type: 'quote',
        text: '保持好奇，也保持克制；参与讨论，也保留判断。',
      },
      {
        type: 'p',
        text: '吃瓜的快乐在于围观，而围观的质量取决于你愿不愿意多想一步。多想一步，你会发现热闹里其实藏着很多值得认真看待的东西。',
      },
    ],
    faq: [
      {
        q: '围观娱乐话题算不算多管闲事？',
        a: '关注公共话题本身没有问题，娱乐内容也是大众文化的一部分。关键区别在于讨论的对象是事还是人：讨论现象和作品属于正常参与，针对个人进行未经证实的指控和攻击则越界了。',
      },
      {
        q: '看到不确定的信息，应该怎么做？',
        a: '最稳妥的做法是先不下结论，明确区分自己确定知道的和只是听说的。可以等更多信息出现，也可以只在自己的小范围内讨论，不要把不确定的说法当作事实继续传播。',
      },
    ],
    related: ['resou-zhiwai', 'lixing-chigua-zhinan', 'wan-geng-dao-zao-geng'],
  },
  {
    slug: 'resou-zhiwai',
    title: '热搜之外：我们到底在关心什么',
    seoTitle: '热搜之外：我们到底在关心什么 - 吃瓜网',
    category: 'guquan-guancha',
    excerpt:
      '热搜榜看起来像一个大杂烩，但它其实在悄悄记录一群人的集体情绪。把它当作情绪地图来读，会得到一个完全不同的视角。',
    lead:
      '我们盯着热搜，常常以为是在关心别人的生活。但仔细想想，真正吸引我们点进去的，往往是那些和自己处境相似的部分。',
    cover:
      'https://readdy.ai/api/search-image?query=Calm%20abstract%20illustration%20of%20a%20long%20vertical%20list%20of%20soft%20rounded%20bars%20with%20one%20highlighted%20in%20coral%2C%20cream%20background%20with%20deep%20green%20accents%2C%20flat%20vector%20editorial%20metaphor%20for%20a%20trending%20list%20reflecting%20public%20emotion&width=1200&height=800&seq=chigua-guancha-02&orientation=landscape',
    tags: ['集体情绪', '注意力', '媒介观察'],
    author: '瓜圈观察组',
    publishedAt: '2026-07-02',
    updatedAt: '2026-07-12',
    readingTime: 5,
    content: [
      {
        type: 'p',
        text: '每天打开热搜榜，看到的都是不同领域的话题拼在一起。它们看起来毫无关系，但如果连着看几天，会发现某种重复出现的情绪线索。',
      },
      {
        type: 'h2',
        text: '热搜是一种情绪快照',
      },
      {
        type: 'p',
        text: '人们在什么话题下停留、讨论、转发，往往和当下的心态有关。当某些主题反复出现，通常说明它触碰到了很多人正在经历的处境。热搜读得久了，你会发现它比想象中更像一张情绪地图。',
      },
      {
        type: 'h2',
        text: '我们真正被什么吸引',
      },
      {
        type: 'list',
        items: [
          '认同感：别人的经历印证了自己正在经历的事。',
          '释放感：借一个公共话题，说出平时不好直接说的话。',
          '好奇心：单纯想知道事情会怎样发展。',
        ],
      },
      {
        type: 'quote',
        text: '我们以为自己在看别人的故事，其实常常是在看自己的影子。',
      },
      {
        type: 'p',
        text: '意识到这一点，并不是要清高地远离热搜，而是提醒自己：你选择停下来看什么，某种程度上也在选择成为什么样的注意力使用者。',
      },
    ],
    related: ['chigua-zhengque-zishi', 'lixing-chigua-zhinan', 'liuliang-tuichao'],
  },
  {
    slug: 'lixing-chigua-zhinan',
    title: '理性吃瓜指南：怎样辨别一条娱乐信息',
    seoTitle: '理性吃瓜指南：怎样辨别一条娱乐信息 - 吃瓜网',
    category: 'guquan-guancha',
    excerpt:
      '娱乐信息的传播速度远快于核实速度。掌握几个简单的检查动作，就能大幅降低被不实信息带着走的概率。',
    lead:
      '面对一条看起来很劲爆的信息，最快能做的不是转发，而是先问三个问题。这三个问题不需要任何专业知识，却能筛掉大部分不靠谱的内容。',
    cover:
      'https://readdy.ai/api/search-image?query=Clean%20illustration%20of%20a%20magnifying%20glass%20over%20loose%20paper%20cards%20with%20soft%20symbols%2C%20cream%20background%20with%20coral%20and%20bamboo%20green%20accents%2C%20flat%20vector%20editorial%20style%20about%20verifying%20information&width=1200&height=800&seq=chigua-guancha-03&orientation=landscape',
    tags: ['信息辨别', '事实核查', '媒介素养'],
    author: '瓜圈观察组',
    publishedAt: '2026-06-15',
    updatedAt: '2026-06-24',
    readingTime: 6,
    editorPick: true,
    content: [
      {
        type: 'p',
        text: '信息传播的速度，永远快过核实的速度。所以与其等着"官方辟谣"，不如自己掌握几个基本的判断动作。下面这套方法不需要专业知识，看完就能用。',
      },
      {
        type: 'h2',
        text: '三个必问的问题',
      },
      {
        type: 'steps',
        items: [
          '这条信息最早的来源是什么？是当事人、权威渠道，还是一个转述了好几手的账号？',
          '它有没有给出可以被验证的细节？含糊的时间、地点、人物往往意味着它无法被核实。',
          '传播它的人能从中获得什么？如果一个账号靠情绪化内容涨粉，它的信息就更需要谨慎对待。',
        ],
      },
      {
        type: 'table',
        head: ['信号', '相对可靠', '需要谨慎'],
        rows: [
          ['来源', '可追溯到具体出处', '只有"据说""网友爆料"'],
          ['表述', '有明确时间地点等细节', '大量模糊的形容和猜测'],
          ['语气', '平实描述', '强烈情绪化、催促转发'],
        ],
      },
      {
        type: 'quote',
        text: '在信息不全的时候，不传播，本身就是一种负责任的选择。',
      },
      {
        type: 'p',
        text: '理性吃瓜不是让人变得冷漠，而是让每一次参与都更值得。你多花的那一分钟，可能就是别人少受的一次误解。',
      },
    ],
    faq: [
      {
        q: '娱乐信息也要这么谨慎吗？',
        a: '娱乐内容同样是公共信息的一部分，而且因为关注度高、传播快，更容易出现未经核实的说法。把它当作其他信息一样对待，花一分钟判断来源，既能避免被误导，也能减少对当事人的误伤。',
      },
      {
        q: '怎样才能快速判断一条信息是否值得转发？',
        a: '可以先看它有没有明确的出处和可验证的细节，再看传播它的账号是否有明显的内容偏好。如果两点都存疑，最稳妥的做法是先不转发，等更可靠的信息出现。',
      },
    ],
    related: ['chigua-zhengque-zishi', 'resou-zhiwai', 'regeng-72xiaoshi'],
  },
];

export const getArticle = (slug: string): Article | undefined =>
  articles.find((a) => a.slug === slug);

export const getArticlesByCategory = (categorySlug: string): Article[] =>
  articles.filter((a) => a.category === categorySlug);

export const getFeatured = (): Article[] => articles.filter((a) => a.featured);

export const getEditorPicks = (): Article[] => articles.filter((a) => a.editorPick);

export const getLatest = (count = 5): Article[] =>
  [...articles]
    .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
    .slice(0, count);

export const getRelated = (article: Article, count = 3): Article[] => {
  const bySlug = (article.related ?? [])
    .map((slug) => articles.find((a) => a.slug === slug))
    .filter((a): a is Article => Boolean(a));
  if (bySlug.length >= count) return bySlug.slice(0, count);
  const fill = articles.filter(
    (a) => a.slug !== article.slug && !bySlug.some((r) => r.slug === a.slug),
  );
  return [...bySlug, ...fill].slice(0, count);
};

export const searchArticles = (keyword: string): Article[] => {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return articles.filter((a) =>
    [a.title, a.excerpt, a.lead, a.tags.join(' '), a.author]
      .join(' ')
      .toLowerCase()
      .includes(q),
  );
};